import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { EnvironmentService } from "../environment.service";
import { map } from "rxjs/operators";
import { ILinkedProductModels, ILinkedProductModel, ILinkedProductPOSTModel } from "../../models/product/dto/linked-products/linked-products.model";
import { ApplicationContextService } from "../application-context.service";

@Injectable({
    providedIn: 'root'
})
export class LinkedProductsService {
    fullPath: string;
    branchCode: string;

    constructor(private readonly httpClient: HttpClient, public envService: EnvironmentService, private applicationContextService: ApplicationContextService) {
        this.fullPath = `${envService.settings.apiUrl}/Products`;
        this.branchCode = this.applicationContextService.getBranchCodeFromUrl();
    }

    public get(productId: number): Observable<ILinkedProductModel[]> {
        return this.httpClient.get<ILinkedProductModels>(`${this.fullPath}/${productId}/linked?branchCode=${this.branchCode}`).pipe(
            map(res => res['linkedProducts'].map((dto: ILinkedProductModel) => dto))
        )
    }

    public save(model: ILinkedProductPOSTModel, productId: number): Observable<ILinkedProductPOSTModel> {
        return this.httpClient.post<ILinkedProductPOSTModel>(`${this.fullPath}/${productId}/linked`, model);
    }

    public delete(ids: number[], productId: number): Observable<boolean> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }), body: {
                productId: productId,
                linkedProductIds: ids
            }
        };

        return this.httpClient.delete<boolean>(`${this.fullPath}/${productId}/linked`, httpOptions);
    }
}